export const changeTemperatureVarietySelectedReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_TemperatureVarietySelected":
      return action.payload.TemperatureVarietySelected;
    default:
      return state;
  }
};
